
<div class="val-mes-preferences val-flex-conteneur val-flex-colonne">
  <div class="val-mes-preferences-titre">{{ Texte("titre", "Mes préférences") }}</div>

  <val-panneau-information>
    <p>{{ Texte("explication", "Vos préférences vous suivent d’un poste et d’un navigateur à l’autre. Seuls les réglages que vous avez modifiés sont enregistrés : les autres gardent leur valeur par défaut.") }}</p>
  </val-panneau-information>

  @if (message)
  {
    <div class="val-mes-preferences-message val-flex-conteneur"
         [class.val-mes-preferences-message-erreur]="message.erreur">
      <val-fonte-icone [iconeCss]="message.erreur ? 'fas fa-exclamation-triangle' : 'fas fa-check-circle'"></val-fonte-icone>
      <div class="val-mes-preferences-message-texte val-flex-1">{{ message.texte }}</div>
      <button kendoButton
              type="button"
              fillMode="flat"
              class="val-mes-preferences-message-fermer"
              iconClass="fas fa-times"
              [title]="Texte('fermer', 'Fermer')"
              (click)="FermerMessage()">
      </button>
    </div>
  }

  @if (chargementEnCours)
  {
    <div class="val-mes-preferences-chargement">{{ Texte("chargement", "Chargement des préférences…") }}</div>
  }
  @else if (erreurChargement)
  {
    <div class="val-mes-preferences-erreur-chargement">{{ Texte("erreur.chargement", "Les préférences n’ont pas pu être chargées. Réessayez plus tard.") }}</div>
  }
  @else
  {
    @if (Langues.length > 1)
    {
      <div class="val-mes-preferences-ligne val-mes-preferences-langue val-flex-conteneur">
        <div class="val-mes-preferences-libelle">{{ Texte("langue.libelle", "Langue de l’interface") }}</div>
        <div class="val-mes-preferences-valeur val-flex-1 val-flex-conteneur">
          @for (langue of Langues; track langue)
          {
            <button kendoButton
                    type="button"
                    class="val-mes-preferences-choix-langue"
                    [attr.data-langue]="langue"
                    [togglable]="true"
                    [selected]="langue === LangueActive"
                    [disabled]="operationEnCours"
                    (click)="ChangerLangue(langue)">
              {{ LibelleLangue(langue) }}
            </button>
          }
        </div>
        <div class="val-mes-preferences-origine">
          {{ LanguePersonnalisee ? Texte("personnalisee", "Personnalisée") : Texte("valeur-defaut", "Valeur par défaut") }}
        </div>
      </div>
    }

    <div class="val-mes-preferences-ligne val-mes-preferences-bandeaux val-flex-conteneur">
      <div class="val-mes-preferences-libelle">{{ Texte("bandeaux.libelle", "Bandeaux des recherches") }}</div>
      <div class="val-mes-preferences-valeur val-flex-1">{{ TexteBandeaux() }}</div>
      <div class="val-mes-preferences-origine">
        {{ NombreBandeauxReplies > 0 ? Texte("personnalisee", "Personnalisée") : Texte("valeur-defaut", "Valeur par défaut") }}
      </div>
    </div>

    <div class="val-mes-preferences-commandes val-flex-conteneur">
      <val-simple-bouton class="val-mes-preferences-retablir"
                         [libelle]="Texte('retablir', 'Rétablir les valeurs par défaut')"
                         [desactive]="operationEnCours"
                         (boutonClick)="Retablir()">
      </val-simple-bouton>
    </div>
  }
</div>

<val-boite-dialogue-generique #boiteDialogueConfirmation
                              class="val-mes-preferences-confirmation"
                              [titre]="Texte('retablir', 'Rétablir les valeurs par défaut')"
                              [validerVisible]="false"
                              [annulerVisible]="false">
  <div contenu>
    <val-simple-panel>
      <val-simple-libelle [libelle]="Texte('confirmation', 'Toutes vos préférences reprendront leur valeur par défaut, et la langue celle de votre compte ou de votre navigateur. Continuer ?')"></val-simple-libelle>
    </val-simple-panel>
  </div>
  <div commandes
       class="val-mes-preferences-confirmation-commandes val-flex-conteneur">
    <div class="val-flex-1"></div>
    <val-simple-bouton class="val-mes-preferences-confirmer"
                       [libelle]="Texte('oui', 'Oui')"
                       (boutonClick)="FermerDialogueConfirmation(true)">
    </val-simple-bouton>
    <val-simple-bouton class="val-mes-preferences-annuler"
                       [libelle]="Texte('non', 'Non')"
                       (boutonClick)="FermerDialogueConfirmation(false)">
    </val-simple-bouton>
  </div>
</val-boite-dialogue-generique>
